import { Action } from '@ngrx/store';
import { RecentRoute } from '../../models/RecentRoutes';

export enum RoutingActionTypes {
  FetchRecentRoutes = '[Routing] Fetch Recent Routes',
  FetchRecentRoutesSuccess = '[Routing] Fetch Recent Routes Success',
  FetchRecentRoutesFailure = '[Routing] Fetch Recent Routes Failure',
  UpdateRecentRoutes = '[Routing] Update Recent Routes',
  UpdateRecentRoutesSuccess = '[Routing] Update Recent Routes Success',
  UpdateRecentRoutesFailure = '[Routing] Update Recent Routes Failure',
}

export class FetchRecentRoutes implements Action {
  readonly type = RoutingActionTypes.FetchRecentRoutes;
}

export class FetchRecentRoutesSuccess implements Action {
  readonly type = RoutingActionTypes.FetchRecentRoutesSuccess;
  constructor(public payload: RecentRoute[]) {}
}
export class FetchRecentRoutesFailure implements Action {
  readonly type = RoutingActionTypes.FetchRecentRoutesFailure;
}
export class UpdateRecentRoutes implements Action {
  readonly type = RoutingActionTypes.UpdateRecentRoutes;
  constructor(public payload: RecentRoute) {}
}
export class UpdateRecentRoutesSuccess implements Action {
  readonly type = RoutingActionTypes.UpdateRecentRoutesSuccess;
  constructor(public payload: RecentRoute[]) {}
}
export class UpdateRecentRoutesFailure implements Action {
  readonly type = RoutingActionTypes.UpdateRecentRoutesFailure;
}

export type RoutingAction =
  | FetchRecentRoutes
  | FetchRecentRoutesSuccess
  | FetchRecentRoutesFailure
  | UpdateRecentRoutes
  | UpdateRecentRoutesSuccess
  | UpdateRecentRoutesFailure;
